import React from 'react';
import styles from './StepNumber.css';

const StepNumber = ({
  children,
  number,
  style,
}) => (
  <div style={{display: 'flex', alignItems:'baseline', marginBottom: '10px', ...style}}>
    <span className={styles.stepNumber}>{number}</span>
    <span>{children}</span>
  </div>
);

export default StepNumber;